import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const ZipCode = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`institutionActivitiesInfo.${index as 0}.zipCode`}
      control={control}
      rules={{
        validate: Validators.required.field
      }}
      render={({ field }) => (
        <FF2
          required
          label="64. ZIP/Postal Code"
          field={field}
          input={(props) => <TextInput {...props} maxLength={9} data-qa="64. ZIP/Postal Code" />}
        />
      )}
    />
  )
}
